import axios from 'axios';
import { CUSTOM_BRANDING, NONE_BRANDING } from './constants';
import { captureException } from '@sentry/browser';

export const updateBrandingReference = async (preference) => {
    return await axios.post('/api/branding/preference',
            { preference },
            {
                withCredentials: true,
                withXSRFToken: true,
                headers: { 'Content-Type': 'application/json' },
            }
    );
};

export const setLogo = (context, { logo, meta } = { logo: NONE_BRANDING.missing, meta: {} }) => {
    if (typeof context.customizations === 'undefined' || typeof context.customizations.branding === 'undefined') return;

    const customizations = context.customizations;

    customizations.branding = customizations.branding.map(branding => {
        if (branding.option === CUSTOM_BRANDING.option) {
            branding.logo = logo;
            branding.meta = meta;
        }
        return branding;
    });

    context.customizations = {};
    context.$nextTick(() => context.customizations = customizations);
};

export const onFailure = ({ exception, defaultMessage }) => {
    captureException(exception);

    const { response } = exception;

    let message = defaultMessage || 'Something went wrong. Please try again later.';

    if (typeof response === 'object' && response?.status === 422) {
        const keys = Object.keys(response.data.errors);

        message = response.data.errors[keys[0]][0] || message;
    }

    return message;
};